import React, { Component } from 'react';
import { CommonlyHead } from '../common/headnav';
import { NewItems } from '../new/item';
import '../new/style.less'
export default class NewDetails extends Component {
    render() {
        return (<div className='new'><CommonlyHead barname="资讯详情" />
        <div className='newDetail'>
            <h1>宁波市6月份健康防病提示</h1>
            <div className="time">2019-05-30 9:06:00 </div>
            </div>
        <NewItems /></div>);
    }

}